import Vue from "vue";
import VueRouter from "vue-router";
import pcpage from "@/components/pc/pcpage";
import pcpage_history from "@/components/pc/pcpage_history";
import home from "@/components/pc/award";
// import home from "@/components/pc/home";
import prizepage from "@/components/pc/prize_page";
import noticelist from "@/components/pc/noticelist";
import notice from "@/components/pc/notice";
import notice_ul from "@/components/pc/notice_ul";
import skill from "@/components/pc/skill";
import skilllist from "@/components/pc/skilllist";
import vlogskill from "@/components/pc/vlogskill";
import makevlogskill from "@/components/pc/makevlogskill";
import plogskill from "@/components/pc/plogskill";
import makeplogskill from "@/components/pc/makeplogskill";
import prize from "@/components/pc/prize";
import userinfo from "@/components/pc/userinfo";
import award from "@/components/pc/award";
import awardinfo from "@/components/pc/awardinfo";

import submitlist from "@/components/pc/submitlist";
import submit from "@/components/pc/submit";
import photo_manage from "@/components/pc/photo_manage";

import submitlist_history from "@/components/pc/historyManage/submitlist";
import submit_history from "@/components/pc/historyManage/submit";
import photo_manage_history from "@/components/pc/historyManage/photo_manage";

import list from "@/components/pc/list";
import vlogdetail from "@/components/pc/vlogdetail";
import plogdetail from "@/components/pc/plogdetail";

import history_home from "@/components/pc/historyWork/history_home";
import history_list from "@/components/pc/historyWork/history_list";
import history_vlogdetail from "@/components/pc/historyWork/vlogdetail";
import history_plogdetail from "@/components/pc/historyWork/plogdetail";

import mpage from "@/components/m/mpage";
import m_home from "@/components/m/m_award";
// import m_home from "@/components/m/m_home";
import m_prizepage from "@/components/m/m_prize_page";
import m_notice from "@/components/m/m_notice";
import m_prize from "@/components/m/m_prize";
import m_skill from "@/components/m/m_skill";
import m_skilllist from "@/components/m/m_skilllist";
import m_vlogskill from "@/components/m/m_vlogskill";
import m_plogskill from "@/components/m/m_plogskill";
import m_makevlogskill from "@/components/m/m_makevlogskill";
import m_makeplogskill from "@/components/m/m_makeplogskill";
import m_vlog_rule from "@/components/m/m_vlog_rule";
import m_pic_rule from "@/components/m/m_pic_rule";
import m_gallery from "@/components/m/m_gallery";
import m_userinfo from "@/components/m/m_userinfo";
import m_submit from "@/components/m/m_submit";
import m_workInfo from "@/components/m/m_workInfo";
import m_uploadpicwork from "@/components/m/m_uploadpicwork";
import m_uploadvideowork from "@/components/m/m_uploadvideowork";
import m_picworksInfo from "@/components/m/m_picworksInfo";
import m_picworkDetail from "@/components/m/m_picworkDetail";
import m_videoworksInfo from "@/components/m/m_videoworksInfo";
import m_guide from "@/components/m/m_guide";
// import m_award from "@/components/m/m_award";
import m_picPriceDetail from "@/components/m/m_picPriceDetail";
import m_videoPriceDetail from "@/components/m/m_videoPriceDetail";
import m_certificateDetail from "@/components/m/m_certificateDetail";
import m_certificateForm from "@/components/m/m_certificateForm";


import m_history_home from "@/components/m/historyWork/history_home";
import m_history_list from "@/components/m/historyWork/history_list";
import m_history_videoworksInfo from "@/components/m/historyWork/m_videoworksInfo";
import m_history_picworksInfo from "@/components/m/historyWork/m_picworksInfo";
import m_history_picworkDetail from "@/components/m/historyWork/m_picworkDetail";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch((err) => err);
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function repalce(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalReplace.call(this, location, onResolve, onReject);
    return originalReplace.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);
const router = new VueRouter({
    routes: [
        {
            path: "/",
            redirect: "/pcpage",
        },
        {
            path: "/pcpage",
            redirect: "/pcpage/home",
            component: pcpage,
            children: [
                {
                    path: "home",
                    component: home,
                },
                
                {
                    path: "noticelist",
                    component: noticelist,
                    redirect: "noticelist/notice_ul",
                    children: [
                        {
                            path: "notice",
                            component: notice,
                        },
                        {
                            path: "notice_ul",
                            component: notice_ul,
                        },
                    ],
                },
                {
                    path: "skill",
                    component: skill,
                    redirect: "skill/skilllist",
                    children: [
                        {
                            path: "skilllist",
                            component: skilllist,
                        },
                        {
                            path: "vlogskill",
                            component: vlogskill,
                        },
                        {
                            path: "makevlogskill",
                            component: makevlogskill,
                        },
                        {
                            path: "plogskill",
                            component: plogskill,
                        },
                        {
                            path: "makeplogskill",
                            component: makeplogskill,
                        },
                    ],
                },
                {
                    path: "prize",
                    component: prize,
                },
                {
                    path: "userinfo",
                    component: userinfo,
                },
                {
                    path: "list",
                    component: list,
                },
                {
                    path: "vlogdetail",
                    component: vlogdetail,
                },
                {
                    path: "plogdetail",
                    component: plogdetail,
                },
                {
                    path: "submitlist",
                    component: submitlist,
                    redirect: "submitlist/submit",
                    children: [
                        {
                            path: "submit",
                            component: submit,
                        },
                        {
                            path: "photo_manage",
                            component: photo_manage,
                        },
                    ],
                },
                {
                    path: "submitlist_history",
                    component: submitlist_history,
                    redirect: "submitlist_history/submit_history",
                    children: [
                        {
                            path: "submit_history",
                            component: submit_history,
                        },
                        {
                            path: "photo_manage_history",
                            component: photo_manage_history,
                        },
                    ],
                },
                {
                    path: "award",
                    component: award,
                },
                {
                    path: "awardinfo",
                    component: awardinfo,
                },
            ],
        },
        {
            path: "/pcpage_history",
            redirect: "/pcpage_history/history_home",
            component: pcpage_history,
            children: [
                {
                    path: "history_home",
                    component: history_home,
                },
                {
                    path: "history_list",
                    component: history_list,
                },
                {
                    path: "vlogdetail",
                    component: history_vlogdetail,
                },
                {
                    path: "plogdetail",
                    component: history_plogdetail,
                },
            ],
        },

        {
            path: "/mpage",
            redirect: "/mpage/m_home",
            component: mpage,
            children: [
                {
                    path: "m_home",
                    component: m_home,
                },
                {
                    path: "m_notice",
                    component: m_notice,
                },
                {
                    path: "m_guide",
                    component: m_guide,
                },
                {
                    path: "m_picPriceDetail",
                    component: m_picPriceDetail,
                },
                {
                  path: 'm_videoPriceDetail',
                  component: m_videoPriceDetail
                },
                {
                  path: 'm_certificateDetail',
                  component: m_certificateDetail
                },
                {
                  path: 'm_certificateForm',
                  component: m_certificateForm
                },
                {
                  path: 'm_history_home',
                  component: m_history_home
                },
                {
                    path: "m_history_list",
                    component: m_history_list,
                },
                {
                    path: "m_history_videoworksInfo",
                    component: m_history_videoworksInfo,
                },
                {
                    path: "m_history_picworksInfo",
                    component: m_history_picworksInfo,
                },
                {
                    path: "m_history_picworkDetail",
                    component: m_history_picworkDetail,
                },
                {
                    path: "m_prize",
                    component: m_prize,
                },
                {
                    path: "m_vlog_rule",
                    component: m_vlog_rule,
                },
                {
                    path: "m_pic_rule",
                    component: m_pic_rule,
                },
                {
                    path: "m_gallery",
                    component: m_gallery,
                },
                {
                    path: "m_userinfo",
                    component: m_userinfo,
                },
                {
                    path: "m_submit",
                    component: m_submit,
                },
                {
                    path: "m_workInfo",
                    component: m_workInfo,
                },
                {
                    path: "m_uploadpicwork",
                    component: m_uploadpicwork,
                },
                {
                    path: "m_uploadvideowork",
                    component: m_uploadvideowork,
                },
                {
                    path: "m_picworksInfo",
                    component: m_picworksInfo,
                },
                {
                    path: "m_picworkDetail",
                    component: m_picworkDetail,
                },
                {
                    path: "m_videoworksInfo",
                    component: m_videoworksInfo,
                },
                {
                    path: "m_skill",
                    component: m_skill,
                    children: [
                        {
                            path: "m_skilllist",
                            component: m_skilllist,
                        },
                        {
                            path: "m_vlogskill",
                            component: m_vlogskill,
                        },
                        {
                            path: "m_makevlogskill",
                            component: m_makevlogskill,
                        },
                        {
                            path: "m_plogskill",
                            component: m_plogskill,
                        },
                        {
                            path: "m_makeplogskill",
                            component: m_makeplogskill,
                        },
                    ],
                },
                {
                    path: "/m_prizeinfo",
                    component: m_prizepage,
                },
            ],
        },
        {
            path: "/prizeinfo",
            component: prizepage,
        },
        // {
        //     path: "/m_prizeinfo",
        //     component: m_prizepage,
        // },
    ],
});
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
        next();
    } else {
        document.title = "中外语言交流合作中心";
        next();
    }
});

export default router;
router.afterEach((to) => {
    if (window.ga) {
        window.ga("set", "page", to.fullPath);
        window.ga("send", "pageview");
    }
});
